import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/hooks/hook";

const CardCheckRoutes = () => {
  const location = useLocation();
  const { card, roles, futurePayment,application_access } = useAppSelector((store: any) => store.user);

  // If the user is an admin, skip the card check
  if (roles === "admin") {
    return <Outlet />;
  }

  // Allow access to /events if futurePayment is true
  if (futurePayment && location.pathname === "/events") {
    return <Outlet />;
  }

  // Redirect to billing if card is false or application access is restricted and the user is not already on the billing page
  if ((!card || !application_access )&& location.pathname !== "/billing") {
    return <Navigate to="/billing" state={{ from: location }} />;
  }

  return <Outlet />;
};

export default CardCheckRoutes;
